// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3-QNa","detailsBorder":"styles_detailsBorder__32kfw"};